<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'

  defineProps<{
    placeholder?: string,
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const text = computed({
    set: (search?: string) => updateRoute({ search: search ? search : undefined }),
    get: () => (route.query.search ?? '') as string,
  })
</script>

<template>
  <app-search
    v-model="text"
    :label="label ?? 'Cari'"
    :placeholder="placeholder ?? 'Cari Produk / Nota...'" />
</template>
